import { styled } from '@mui/material/styles';
import { IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useTranslation } from 'react-i18next';

const StyledMobileNavButton = styled(IconButton)(({ theme }) => ({
  position: 'fixed',
  top: theme.spacing(3),
  right: theme.spacing(3),
  zIndex: theme.zIndex.appBar,
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
}));

type Props = {
  onClick: () => void;
};

export const MobileNavButton = ({ onClick }: Props) => {
  const { t } = useTranslation();
  return (
    <StyledMobileNavButton onClick={onClick} aria-label={t('navbar.openMenu')} data-testid="mobile-nav-button">
      <MenuIcon />
    </StyledMobileNavButton>
  );
};